"use strict";
import { BigNumber } from "@ethersproject/bignumber";
function normalizeMintRawAmount(amountRaw, fromDecimals, toDecimals) {
  if (fromDecimals === toDecimals) {
    return amountRaw;
  }
  if (fromDecimals < toDecimals) {
    return amountRaw * 10n ** BigInt(toDecimals - fromDecimals);
  }
  return amountRaw / 10n ** BigInt(fromDecimals - toDecimals);
}
export function isUsdrMintPrecisionSafe(amountInRaw, inputDecimals, usdrDecimals = 18) {
  if (inputDecimals <= usdrDecimals) {
    return true;
  }
  const divisor = 10n ** BigInt(inputDecimals - usdrDecimals);
  return amountInRaw % divisor === 0n;
}
export function getMintOutputAmount(amountInRaw, inputDecimals, usdrDecimals) {
  return BigNumber.from(normalizeMintRawAmount(BigInt(amountInRaw.toString()), inputDecimals, usdrDecimals).toString());
}
